import { ActionsUnion, createAction, createActionWithCallback, createThunkActionType } from "../../../platform/redux/ActionHelper";
import { ITestConfiguration } from "../Contracts";

export enum TestActionTypes {
    InitTestView = "Test/InitTestView",

    SetTestConfig = "Test/SetTestConfig",

    FetchPartnerList = "Test/FetchPartnerList",
    FetchPartnerListSuccess = "Test/FetchPartnerListSuccess",
    FetchPartnerListFailure = "Test/FetchPartnerListFailure",

    FetchPartnerHeaders = "Test/FetchPartnerHeaders",
    FetchPartnerHeadersSuccess = "Test/FetchPartneHeadersSuccess",
    FetchPartnerHeadersFailure = "Test/FetchPartnerHeadersFailure",

    FetchPartnerFooters = "Test/FetchPartnerFooters",
    FetchPartnerFootersSuccess = "Test/FetchPartnerFootersSuccess",
    FetchPartnerFootersFailure = "Test/FetchPartnerFootersFailure",
}

const TestStandardActions = {
    initTestView: () => createAction(TestActionTypes.InitTestView),

    setTestConfig: (config: ITestConfiguration) => createAction(TestActionTypes.SetTestConfig, config),

    fetchPartnerListSuccess: (partners: string[]) => createAction(TestActionTypes.FetchPartnerListSuccess, partners),
    fetchPartnerListFailure: (error: string) => createAction(TestActionTypes.FetchPartnerListFailure, error),

    fetchPartnerHeadersSuccess: (headers: string[]) => createAction(TestActionTypes.FetchPartnerHeadersSuccess, headers),
    fetchPartnerHeadersFailure: (error: string) => createAction(TestActionTypes.FetchPartnerHeadersFailure, error),

    fetchPartnerFootersSuccess: (footers: string[]) => createAction(TestActionTypes.FetchPartnerFootersSuccess, footers),
    fetchPartnerFootersFailure: (error: string) => createAction(TestActionTypes.FetchPartnerFootersFailure, error)
}

const TestThunkActions = {
    fetchPartnerList: () => createActionWithCallback<string[]>(TestActionTypes.FetchPartnerList),
    fetchPartnerHeaders: (partnerId: string) => createActionWithCallback<string[]>(TestActionTypes.FetchPartnerHeaders, partnerId),
    fetchPartnerFooters: (partnerId: string) => createActionWithCallback<string[]>(TestActionTypes.FetchPartnerFooters, partnerId)
}  

const TestThunkActionsTypes = {
    fetchPartnerList: () => createThunkActionType(TestActionTypes.FetchPartnerList),
    fetchPartnerHeaders: (partnerId: string) => createThunkActionType(TestActionTypes.FetchPartnerHeaders, partnerId),
    fetchPartnerFooters: (partnerId: string) => createThunkActionType(TestActionTypes.FetchPartnerFooters, partnerId)
}

export const TestActions = {...TestStandardActions, ...TestThunkActions};
const AllActionsTypes = {...TestStandardActions, ...TestThunkActionsTypes};
export type TestActionsType = ActionsUnion<typeof AllActionsTypes>;
